import React, { useState, useRef, useEffect } from 'react';
import { Badge } from 'react-bootstrap';
import { useNotifications } from '../../contexts/NotificationContext';
import NotificationDropdown from './NotificationDropdown';
import './Notifications.css';

const NotificationBell = () => {
  const { unreadCount } = useNotifications();
  const [isOpen, setIsOpen] = useState(false);
  const bellRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (bellRef.current && !bellRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const displayCount = unreadCount > 99 ? '99+' : unreadCount;

  return (
    <div className="notification-bell-wrapper" ref={bellRef}>
      <button
        className="navbar-icon-btn notification-bell-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Notificaciones"
      >
        <i className={`bi bi-bell${unreadCount > 0 ? '-fill' : ''}`}></i>
        {unreadCount > 0 && (
          <Badge bg="danger" pill className="navbar-icon-badge notification-badge">
            {displayCount}
          </Badge>
        )}
      </button>
      {isOpen && <NotificationDropdown onClose={() => setIsOpen(false)} />}
    </div>
  );
};

export default NotificationBell;
